import { useState } from "react";
import { NavLink } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import logo1 from "../../assets/logo1.png";

const menuItems = [
  { label: "Breakfast", path: "/menu/breakfast" },
  { label: "Lunch", path: "/menu/lunch" },
  { label: "Dinner", path: "/menu/dinner" },
  { label: "Drinks", path: "/menu/drinks" },
  { label: "Desserts", path: "/menu/desserts" },
];

const navLinkClass = ({ isActive }) =>
  `relative inline-block px-1 pb-1 transition-colors duration-200
   ${
     isActive
       ? "text-primary-700 after:absolute after:left-0 after:bottom-0 after:h-[2px] after:w-full after:bg-primary-700"
       : "hover:text-primary-700"
   }`;

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);       
  const [mobileOpen, setMobileOpen] = useState(false);  
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-white/90 backdrop-blur shadow-sm">
     
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">

        {/* LOGO */}
        <NavLink to="/" className="flex items-center shrink-0">
          <img
            src={logo1}
            alt="Restaurant Logo"
            className="w-32 sm:w-40 h-auto object-contain"
          />
        </NavLink>

        <nav className="hidden md:flex items-center gap-8 text-sm font-semibold text-primary-700">
          <NavLink to="/" className={navLinkClass}>
            HOME
          </NavLink>

          <div className="relative">
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="flex items-center gap-1 hover:text-primary-700"
            >
              MENU <KeyboardArrowDownIcon fontSize="small" />
            </button>

            {menuOpen && (
              <ul className="absolute top-8 left-0 w-44 bg-white shadow-lg rounded-md overflow-hidden">
                {menuItems.map((item) => (
                  <li key={item.path}>
                    <NavLink
                      to={item.path}
                      onClick={() => setMenuOpen(false)}
                      className={({ isActive }) =>
                        `block px-4 py-2 text-sm ${
                          isActive
                            ? "bg-primary-50 font-semibold"
                            : "hover:bg-primary-50"
                        }`
                      }
                    >
                      {item.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            )}
          </div>

          <NavLink to="/about" className={navLinkClass}>
            ABOUT
          </NavLink>

          <NavLink to="/contact" className={navLinkClass}>
            CONTACT
          </NavLink>
        </nav>

        <button
          className="md:hidden text-primary-700"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <CloseIcon /> : <MenuIcon />}
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white shadow-lg px-4 py-4 space-y-4 text-sm font-semibold text-primary-700">
          <NavLink
            to="/"
            onClick={() => setMobileOpen(false)}
            className="block"
          >
            HOME
          </NavLink>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="flex items-center justify-between w-full"
          >
            MENU <KeyboardArrowDownIcon />
          </button>

          {mobileMenuOpen && (
            <div className="pl-4 space-y-2">
              {menuItems.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  onClick={() => {
                    setMobileMenuOpen(false);
                    setMobileOpen(false);
                  }}
                  className="block text-sm hover:text-primary-700"
                >
                  {item.label}
                </NavLink>
              ))}
            </div>
          )}

          <NavLink
            to="/about"
            onClick={() => setMobileOpen(false)}
            className="block"
          >
            ABOUT
          </NavLink>

          <NavLink
            to="/contact"
            onClick={() => setMobileOpen(false)}
            className="block"
          >
            CONTACT
          </NavLink>
        </div>
      )}
    </header>
  );
};

export default Navbar;
